module.exports = __webpack_public_path__ + "img/icon_2_14.973dee1e.png";